<script>
  import Navigation from "../components/UI/Navigation.svelte";
  import Icon from "svelte-awesome";
  import { envelope, phone, linkedin } from "svelte-awesome/icons";
  import { contactItems } from "../constants/content";
</script>

<style>
  .container {
    color: var(--color-theme-4);
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
  .row {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
  }
  .contact-item {
    margin-bottom: 2rem;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    display: flex;
  }
  .icon {
    background-color: var(--color-theme-2);
    border-radius: 100%;
    overflow: hidden;
    padding: 1rem;
    width: 5rem;
    height: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon-text {
    margin-bottom: 0;
  }
</style>

<div class="container">

  <Navigation />
  <h1 class="is-center">Contact</h1>
  <div class="row is-center">
    <!-- <div class="content"> -->

    {#each contactItems as item}
      <div class="col-12 col-3-md _col-3-lg contact-item">
        <div class="icon">
          <Icon data={item.icon} />
        </div>
        <h5 class="icon-text">{item.text}</h5>
        <p>
          <a href={item.url} target="_blank">{item.label}</a>
        </p>
      </div>
    {/each}
    <!-- </div> -->
  </div>
</div>
